

import React, { useState } from "react";
import SMAImg from "../../assets/SMA.png";
import SEO from "../SEO";
import Header from "./Header";
import Footer from "./Footer";

const Sma = () => {
  const [language, setLanguage] = useState("english"); // "english" or "hindi"

  return (
    <div className="w-screen h-full">
      <Header />

      <div className="bg-white/10 backdrop-blur-md m-3 rounded-lg">
        <div className="px-4 py-5 bg-white/20">
          {/* Hero Image */}
          <div className="rounded-xl flex justify-center overflow-hidden shadow-lg">
            <img
              src={SMAImg}
              alt="SMA Indicator"
              className="object-cover h-72 w-full"
            />
          </div>

          {/* Category Tag */}
          <div className="mt-6">
            <span className="inline-block bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
              Technical Indicator
            </span>
          </div>

          {/* Title */}
          <div className="w-full  rounded-md p-4 mt-2  flex flex-col items-center justify-between">

            <div className="">
              <h1 className="text-3xl  sm:text-4xl font-bold text-center text-black mt-4 leading-tight">
                Understanding the Simple Moving Average (SMA) Indicator
              </h1>
            </div>


            {/* Language Toggle Buttons */}
            <div className="flex flex-wrap m-4 gap-3">
              <button
                onClick={() => setLanguage("english")}
                className={`p-2 font-bold rounded-md ${language === "english"
                  ? "bg-blue-500 text-white"
                  : "bg-blue-200 text-black"
                  }`}
              >
                English
              </button>

              <button
                onClick={() => setLanguage("hindi")}
                className={`p-2 font-bold rounded-md ${language === "hindi"
                  ? "bg-blue-500 text-white"
                  : "bg-blue-200 text-black"
                  }`}
              >
                हिन्दी
              </button>
            </div>

            {/* Language Content */}
            <div className="w-full mt-4">
              {language === "hindi" && (
                <div>

                  <p className="mt-6 text-black leading-relaxed">
                    सरल मूविंग एवरेज (SMA) ट्रेडिंग में सबसे अधिक उपयोग किए जाने वाले तकनीकी संकेतकों में से एक है। यह मूल्य डेटा को औसत करके स्मूथ करता है,
                    और निर्दिष्ट अवधि के लिए क्लोजिंग प्राइस का औसत निकालता है। व्यापारी SMA का उपयोग प्रवृत्तियों की पहचान करने, संकेतों की पुष्टि करने,
                    और समर्थन और प्रतिरोध स्तरों का विश्लेषण करने के लिए करते हैं। चाहे आप तकनीकी विश्लेषण में नए हों या अनुभवी व्यापारी, SMA में दक्षता
                    आपकी ट्रेडिंग रणनीति को बेहतर बना सकती है।
                  </p>

                  {/* Getting Started Section */}
                  <div className="w-full">
                    <h2 className="text-2xl font-semibold mt-10 text-black">
                      ट्रेडिंग में SMA कैसे सेट करें
                    </h2>

                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                      <li>
                        <strong>अपने ट्रेडिंग प्लेटफॉर्म को खोलें:</strong> अपने पसंदीदा ट्रेडिंग प्लेटफॉर्म (जैसे TradingView, Zerodha, या Upstox) में लॉग इन करें जहां आप मूल्य चार्ट का विश्लेषण करते हैं।
                      </li>
                      <li>
                        <strong>चार्ट चुनें:</strong> उस स्टॉक, मुद्रा जोड़ी या एसेट को चुनें जिसे आप विश्लेषित करना चाहते हैं और उसका मूल्य चार्ट खोलें (कैंडलस्टिक चार्ट आमतौर पर उपयोग किया जाता है)।
                      </li>
                      <li>                       <strong>Indicators मेन्यू एक्सेस करें:</strong> चार्ट टूलबार पर <em>Indicators</em> विकल्प पर क्लिक करें और <em>Simple Moving Average (SMA)</em> खोजें।
                      </li>
                      <li>
                        <strong>समय अवधि सेट करें:</strong> SMA जोड़ने के बाद इसकी सेटिंग्स (गियर आइकन ⚙️) एडिट करें और वांछित अवधि चुनें, जैसे 20, 50, या 200।                         <br />- <em>शॉर्ट-टर्म SMA (जैसे 20)</em> मूल्य परिवर्तनों पर जल्दी प्रतिक्रिया करता है।
                        <br />- <em>लॉन्ग-टर्म SMA (जैसे 200)</em> दीर्घकालिक प्रवृत्तियों को दिखाता है।
                      </li>
                      <li>
                        <strong>लागू करें और विश्लेषण करें:</strong> SMA को चार्ट पर लागू करें और देखें कि मूल्य कैसे व्यवहार करता है:
                        <br />- यदि मूल्य SMA के ऊपर रहता है, तो यह <em>अपट्रेंड</em> का संकेत हो सकता है।
                        <br />- यदि मूल्य SMA के नीचे रहता है, तो यह <em>डाउनट्रेंड</em> का संकेत हो सकता है।
                      </li>
                      <li>
                        <strong>अन्य संकेतकों के साथ संयोजन करें:</strong> बेहतर सटीकता के लिए, SMA का उपयोग RSI या MACD जैसे अन्य उपकरणों के साथ करें।
                      </li>
                    </ol>

                    {/* What SMA Can Do */}
                    <h2 className="text-2xl font-semibold mt-10 text-black">SMA क्या कर सकता है</h2>
                    <ol className="list-disc pl-5 space-y-2">
                      <li>
                        <strong>ट्रेंड की दिशा पहचानें:</strong> SMA मूल्य उतार-चढ़ाव को स्मूथ करके कुल बाजार प्रवृत्ति निर्धारित करने में मदद करता है।
                      </li>
                      <li>
                        <strong>समर्थन और प्रतिरोध स्तर:</strong> SMA लाइनें अक्सर डायनामिक सपोर्ट या रेसिस्टेंस के रूप में काम करती हैं। मूल्य इन लाइनों से उछल सकता है।
                      </li>
                      <li>
                        <strong>बाजार शोर को फ़िल्टर करें:</strong> निर्दिष्ट अवधि पर डेटा का औसत लेने से SMA अल्पकालिक उतार-चढ़ाव को कम करता है।                       </li>
                      <li>
                        <strong>ट्रेंडिंग मार्केट में बेहतर उपयोग:</strong> SMA तब अच्छा काम करता है जब बाजार एक दिशा में मजबूत रूप से चल रहा हो।
                      </li>
                      <li>
                        <strong>रणनीति के अनुसार अवधि चुनें:</strong> शॉर्ट-टर्म ट्रेडर्स 10- या 20-दिन SMA का उपयोग करते हैं, जबकि लॉन्ग-टर्म ट्रेडर्स 50- या 200-दिन SMA को पसंद करते हैं।
                      </li>
                      <li>
                        <strong>अन्य संकेतकों के साथ संयोजन:</strong> बेहतर सटीकता के लिए SMA का उपयोग RSI या MACD के साथ करें।
                      </li>
                    </ol>

                    {/* When to Use SMA */}
                    <h2 className="text-2xl font-semibold mt-10 text-black">SMA का उपयोग कब करें</h2>
                    <ol className="list-disc pl-5 space-y-2">
                      <li>                         <strong>उभरते हुए ट्रेंड की पहचान:</strong> नए अपट्रेंड या डाउनट्रेंड की शुरुआत को देखने के लिए SMA का उपयोग करें।
                      </li>
                      <li>
                        <strong>ट्रेंड की ताकत की पुष्टि:</strong> जब मूल्य लगातार बढ़ते हुए SMA के ऊपर रहता है, तो यह मजबूत अपट्रेंड की पुष्टि करता है।
                      </li>                       <li>
                        <strong>एंट्री और एग्जिट पॉइंट्स ढूँढना:</strong> क्रॉसओवर का उपयोग करें (जैसे शॉर्ट-टर्म SMA का लॉन्ग-टर्म SMA को पार करना)।
                      </li>
                      <li>
                        <strong>दीर्घकालिक निवेश की योजना:</strong> लॉन्ग-टर्म SMA का उपयोग स्टॉक या एसेट के स्वास्थ्य का मूल्यांकन करने के लिए किया जाता है।
                      </li>
                      <li>                        <strong>अस्थिर बाजार में शोर को फ़िल्टर करें:</strong> अस्थिर परिस्थितियों में, SMA मूल्य आंदोलनों को स्मूथ करता है।
                      </li>
                    </ol>

                    {/* Pros/Cons */}
                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                      <li>
                        <strong>फायदे:</strong>
                        <br />- सरल और आसानी से समझने योग्य।
                        <br />- कुल बाजार प्रवृत्तियों की पहचान में मदद करता है।
                        <br />- अल्पकालिक उतार-चढ़ाव से शोर कम करता है।
                        <br />- व्यापारियों द्वारा व्यापक रूप से उपयोग और मान्यता प्राप्त।                      </li>

                      <li>
                        <strong>नुकसान:</strong>
                        <br />- बाजार के पीछे रहता है — मूल्य परिवर्तनों पर धीरे प्रतिक्रिया करता है।
                        <br />- अस्थिर या साइडवेज मार्केट में गलत संकेत दे सकता है।
                        <br />- बहुत अल्पकालिक ट्रेडिंग रणनीतियों के लिए उपयुक्त नहीं।
                        <br />- भविष्य की कीमत की भविष्यवाणी नहीं करता।
                      </li>
                    </ul>

                    {/* Python Section */}
                    <div className="mt-6 w-[500px] p-4 lg:w-full md:w-full sm:w-full ">
                      <h2 className="text-xl sm:text-2xl font-semibold text-black">
                        📈 Python का उपयोग करके SMA सिग्नल उत्पन्न करें
                      </h2>

                      <p className="mt-4 text-black leading-relaxed text-sm sm:text-base">
                        आप <strong>Yahoo Finance</strong> से ऐतिहासिक मूल्य डेटा प्राप्त कर सकते हैं और <strong>TA-Lib</strong> का उपयोग करके SMA की गणना कर सकते हैं। एक सरल रणनीति:                      </p>

                      <ul className="list-disc ml-4 sm:ml-6 mt-3 space-y-2 text-black text-sm sm:text-base">
                        <li>जब शॉर्ट-टर्म SMA लॉन्ग-टर्म SMA के ऊपर जाए → <em>खरीद संकेत</em>।</li>                        <li>जब शॉर्ट-टर्म SMA लॉन्ग-टर्म SMA के नीचे जाए → <em>बिक्री संकेत</em>।</li>                        <li>सिग्नलों की पुष्टि के लिए SMA को RSI या MACD जैसे संकेतकों के साथ संयोजन करें।</li>                      </ul>
                    </div>
                  </div>

                  <p className="mt-6 text-black leading-relaxed">
                    सरल मूविंग एवरेज (SMA) ट्रेडिंग में सबसे अधिक उपयोग किए जाने वाले तकनीकी संकेतकों में से एक है...
                  </p>

                  {/* Add full Hindi content here, like your existing SMA sections */}
                </div>
              )}

              {language === "english" && (
                <div>
                  <p className="mt-6 text-black leading-relaxed">
                    The Simple Moving Average (SMA) is one of the most widely used
                    technical indicators in trading. It helps smooth out price data by
                    calculating the average closing price over a specified number of
                    periods. Traders use SMA to identify trends, confirm signals, and
                    analyze support and resistance levels. Whether you're new to
                    technical analysis or an experienced trader, mastering SMA can
                    enhance your trading strategy.
                  </p>

                  <div className="w-full">
                    <h2 className="text-2xl font-semibold mt-10 text-black">
                      How to Set SMA in Trading
                    </h2>

                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                      <li>
                        <strong>Open Your Trading Platform:</strong> Log in to your preferred
                        trading platform (such as TradingView, Zerodha, or Upstox) where you
                        analyze price charts.
                      </li>

                      <li>
                        <strong>Select a Chart:</strong> Choose the stock, currency pair, or
                        asset you want to analyze and open its price chart (candlestick chart is
                        commonly used).
                      </li>

                      <li>
                        <strong>Access the Indicators Menu:</strong> On the chart toolbar, click
                        on the <em>Indicators</em> option and search for{" "}
                        <em>Simple Moving Average (SMA)</em>.
                      </li>

                      <li>
                        <strong>Set the Time Period:</strong> After adding the SMA, edit its
                        settings (gear icon ⚙️) and choose the desired period, such as 20, 50, or
                        200.
                        <br />- <em>Short-term SMA (e.g. 20)</em> reacts quickly to price changes.
                        <br />- <em>Long-term SMA (e.g. 200)</em> shows long-term trends.
                      </li>

                      <li>
                        <strong>Apply and Analyze:</strong> Apply the SMA to your chart and
                        observe how price behaves:
                        <br />- If price stays above SMA, it may signal an{" "}
                        <em>uptrend</em>.
                        <br />- If price stays below SMA, it may signal a{" "}
                        <em>downtrend</em>.
                      </li>

                      <li>
                        <strong>Combine with Other Indicators:</strong> For better accuracy, use
                        SMA along with other tools like RSI or MACD to confirm your signals.
                      </li>


                    </ol>


                    <h2 className="text-2xl font-semibold mt-10 text-black">
                      What SMA Can Do
                    </h2>

                    <ol className="list-disc pl-5 space-y-2">
                      <li>
                        <strong>Identify Trend Direction:</strong> SMA helps determine the overall market trend by smoothing out price fluctuations.
                        An upward-sloping SMA indicates an uptrend, while a downward-sloping SMA shows a downtrend.
                      </li>

                      <li>
                        <strong>Spot Support and Resistance Levels:</strong> SMA lines often act as dynamic support or resistance.
                        Prices may bounce off these lines, making them useful for entry and exit points.
                      </li>

                      <li>
                        <strong>Filter Market Noise:</strong> By averaging price data over a set period, SMA reduces short-term volatility
                        and reveals the true underlying price movement.
                      </li>

                      <li>
                        <strong>Best Used in Trending Markets:</strong> SMA works well when the market is moving strongly in one direction,
                        but may give false signals in sideways or choppy markets.
                      </li>

                      <li>
                        <strong>Choose Period Based on Strategy:</strong> Short-term traders often use 10- or 20-day SMAs for quick signals,
                        while long-term traders may prefer 50- or 200-day SMAs to capture major trends.
                      </li>

                      <li>
                        <strong>Combine with Other Indicators:</strong> For better accuracy, use SMA along with tools like RSI or MACD
                        to confirm your trading signals.
                      </li>
                    </ol>


                    {/* <h3 className="text-xl font-semibold mt-6 mb-2">When to Use SMA</h3> */}

                    <h2 className="text-2xl font-semibold mt-10 text-black">
                      When to Use SMA
                    </h2>

                    <ol className="list-disc pl-5 space-y-2">
                      <li>
                        <strong>Identifying Emerging Trends:</strong> Use SMA to spot the beginning of new uptrends or downtrends
                        when price crosses above or below the SMA line.
                      </li>

                      <li>
                        <strong>Confirming Trend Strength:</strong> When price consistently stays above a rising SMA,
                        it confirms a strong uptrend, and vice versa for downtrends.
                      </li>

                      <li>
                        <strong>Finding Entry and Exit Points:</strong> Use crossovers (e.g., short-term SMA crossing above a long-term SMA)
                        to decide when to enter or exit trades.
                      </li>

                      <li>
                        <strong>Planning Long-Term Investments:</strong> Long-term SMAs (like 100- or 200-day) are useful for
                        evaluating the overall health of a stock or asset before investing.
                      </li>

                      <li>
                        <strong>Filtering Out Noise in Volatile Markets:</strong> In volatile conditions, SMA helps smooth price movements
                        so you can focus on the broader direction rather than short-term spikes.
                      </li>
                    </ol>



                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                      <li>
                        <strong> Pros:</strong>
                        <br />- Simple to calculate and easy to understand.
                        <br />- Helps identify overall market trends.
                        <br />- Reduces noise from short-term price fluctuations.
                        <br />- Widely used and recognized by traders.
                      </li>

                      <li>
                        <strong>Cons:</strong>
                        <br />- Lags behind the market — reacts slowly to price changes.
                        <br />- May give false signals in volatile or sideways markets.
                        <br />- Not suitable for very short-term trading strategies.
                        <br />- Does not predict future price movements.
                      </li>
                    </ul>


                  </div>


                  {/* Add full English content here, like your existing SMA sections */}

                  <h2 className="text-xl sm:text-2xl font-semibold text-black">
                    📈 Generate SMA Signals Using Python
                  </h2>

                  <p className="mt-4 text-black leading-relaxed text-sm sm:text-base">
                    You can fetch historical price data from <strong>Yahoo Finance</strong> and
                    use <strong>TA-Lib</strong> to calculate SMA. A simple strategy is:
                  </p>

                  <ul className="list-disc ml-4 sm:ml-6 mt-3 space-y-2 text-black text-sm sm:text-base">
                    <li>
                      When the short-term SMA crosses above the long-term SMA → <em>Buy Signal</em>.
                    </li>
                    <li>
                      When the short-term SMA crosses below the long-term SMA → <em>Sell Signal</em>.
                    </li>
                    <li>
                      Combine SMA with indicators like RSI or MACD to confirm signals.
                    </li>
                  </ul>

                </div>
              )}
            </div>
          </div>

          {/* Python SMA Example */}
          <div className="mt-6 w-[450px] p-4 lg:w-full md:w-full sm:w-full">
            {/* <h2 className="text-xl sm:text-2xl font-semibold text-black">
              📈 Generate SMA Signals Using Python
            </h2>

            <p className="mt-4 text-black leading-relaxed text-sm sm:text-base">
              You can fetch historical price data from <strong>Yahoo Finance</strong> and
              use <strong>TA-Lib</strong> to calculate SMA. A simple strategy is:
            </p>

            <ul className="list-disc ml-4 sm:ml-6 mt-3 space-y-2 text-black text-sm sm:text-base">
              <li>
                When the short-term SMA crosses above the long-term SMA → <em>Buy Signal</em>.
              </li>
              <li>
                When the short-term SMA crosses below the long-term SMA → <em>Sell Signal</em>.
              </li>
              <li>
                Combine SMA with indicators like RSI or MACD to confirm signals.
              </li>
            </ul> */}

            <div className="mt-6 bg-gray-900 text-green-300 p-3 sm:p-4 rounded-lg overflow-x-auto">
              <pre className="text-xs sm:text-sm min-w-full">
                <code>{`
import yfinance as yf
import pandas as pd
import talib

# Fetch historical data for NSE stock (e.g., Reliance)
ticker = "RELIANCE.NS"
data = yf.download(ticker, start="2024-08-01", end="2024-09-01", interval="1d")

# Calculate short & long SMA
data['SMA_20'] = talib.SMA(data['Close'], timeperiod=20)
data['SMA_50'] = talib.SMA(data['Close'], timeperiod=50)

# Generate Buy/Sell signals
data['Signal'] = None
for i in range(1, len(data)):
    if data['SMA_20'][i] > data['SMA_50'][i] and data['SMA_20'][i-1] <= data['SMA_50'][i-1]:
        data.at[i, 'Signal'] = 'BUY'
    elif data['SMA_20'][i] < data['SMA_50'][i] and data['SMA_20'][i-1] >= data['SMA_50'][i-1]:
        data.at[i, 'Signal'] = 'SELL'

print(data[['Close','SMA_20','SMA_50','Signal']].dropna())
                `}</code>
              </pre>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Sma;
